const specs = {
  width: 620,
  title: {
    update: 'pages.securityMeasures.modal.update.single.title',
    create: 'pages.securityMeasures.modal.create.single.title'
  },
  okText: {
    update: 'pages.securityMeasures.modal.update.single.okText',
    create: 'pages.securityMeasures.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.securityMeasures.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.securityMeasures.fields.name.title',
        required: 'pages.securityMeasures.fields.name.requiredMessage',
        placeholder: 'pages.securityMeasures.fields.name.placeholder'
      },
      empty: 'common.unknown.male'
    }
  }
}

export default specs
